import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  LeaveRequestsCounts,
  LeaveRequestsListResponse,
} from "@/actions/ssr/leave/getLeaveRequestsSSR";

const EMPTY_COUNTS: LeaveRequestsCounts = {
  total: 0,
  pending: 0,
  approved: 0,
  rejected: 0,
  revoked: 0,
};

interface LeaveRequestsState extends LeaveRequestsListResponse {
  clientFetched: boolean;
}

const initialState: LeaveRequestsState = {
  count: 0,
  total_pages: 0,
  current_page: 1,
  results: [],
  counts: { ...EMPTY_COUNTS },
  global_counts: { ...EMPTY_COUNTS },
  clientFetched: false,
};

const leaveRequestsSlice = createSlice({
  name: "leaveRequests",
  initialState,
  reducers: {
    setLeaveRequests(state, action: PayloadAction<LeaveRequestsListResponse>) {
      state.clientFetched = true;
      state.count = action.payload.count;
      state.total_pages = action.payload.total_pages;
      state.current_page = action.payload.current_page;
      state.results = action.payload.results;
      state.counts = action.payload.counts;
      state.global_counts = action.payload.global_counts;
    },
    setLeaveRequestsFromSSR(
      state,
      action: PayloadAction<LeaveRequestsListResponse>,
    ) {
      if (state.clientFetched) return;
      state.count = action.payload.count;
      state.total_pages = action.payload.total_pages;
      state.current_page = action.payload.current_page;
      state.results = action.payload.results;
      state.counts = action.payload.counts;
      state.global_counts = action.payload.global_counts;
    },
  },
});

export const { setLeaveRequests, setLeaveRequestsFromSSR } =
  leaveRequestsSlice.actions;
export default leaveRequestsSlice.reducer;
